import styled from "styled-components";

export const Container = styled.div`
  padding: 22px 30px;
  background-color: #fafcff;
  max-height: calc(100vh - 60px);
  overflow: auto;
  .label {
    font-size: 13px;
    color: #1d1d1d;
    margin-bottom: 4px;
  }
`;

export const Heading = styled.div`
  padding-right: 25px;
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
  gap: 14px;
  width: 100%;
  /* .add-new-msg {
    background-color: var(--input-background);
  } */
  h3 {
    font-weight: 700;
    font-size: 16px;
    line-height: 31px;
    color: #000000;
  }
  h2 {
    font-weight: 700;
    font-size: 24px;
    line-height: 31px;
    color: #000000;
  }
  p {
    font-size: 14px;
    color: #000000b3;
  }
`;

export const BoxContainer = styled.div`
  margin-bottom: 24px;
`;

export const WorkSection = styled.div`
  background: #ffffff;
  box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.05);
  padding: 27px 30px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(270px, 1fr));
  gap: 30px 7.708vw;
  &.TeeMarkerSettings-main-container {
    grid-template-columns: 1fr;
    padding-top: 0;
  }
  label {
    font-size: 13px;
    color: #1d1d1d;
    margin-bottom: 4px;
  }
  .tee-marker-settings-header {
    background: #6b5c4b;
    padding: 11px 17px;
    gap: 10px;
    display: flex;
    align-items: center;
    .checkbox-wrapper {
      background: #ffffff;
      border: 1px solid #cdcfd0;
      border-radius: 6px;
      padding: 4px 10px;
      .MuiFormControlLabel-label {
        font-size: 13px;
      }
      .MuiFormControlLabel-root {
        margin: 0;
        display: flex;
        align-items: center;
        gap: 10px;
      }
      .MuiCheckbox-root {
        padding: 0;
      }
    }
    button {
      border: 1px solid #bc9b6a;
      border-radius: 6px;
      background: transparent;
      color: #fff;
      min-height: 31px;
      padding: 0 10px;
      :first-child {
        margin-right: 10px;
        position: relative;
        ::after {
          content: "";
          display: block;
          height: calc(100% - 4px);
          width: 1px;
          background-color: #cdcfd080;
          position: absolute;
          right: -10px;
          top: 2px;
        }
      }
      &.active {
        background: #bc9b6a;
        border: 1px solid #bc9b6a;
      }
    }
  }
  .TeeMarkerSettingsWrapper {
    display: flex;
    justify-content: space-between;
    gap: 15px;
    flex-wrap: wrap;
  }
  input {
    background: #ffffff;
    border: 1px solid #cdcfd0;
    border-radius: 6px;
    height: 30px;
    display: block;
    width: 100%;
    margin-bottom: 10px;
    :disabled {
      background: #eee;
    }
  }
  .preview {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    gap: 20px;
    margin: 27px 1px 0px 0px;
    p {
      font-size: 13px;
      line-height: 16px;
    }
    h6 {
      font-weight: 700;
      font-size: 16px;
      line-height: 150.5%;
    }
  }
  .select-wrapper {
    .select {
      margin-bottom: 10px;
      margin-top: 4px;
    }
    label {
      font-size: 13px;
      color: #1d1d1d;
    }
    .MuiFormControl-root {
      margin: 0;
      /* width: 50%; */
    }
    .MuiSelect-select {
      background: #ffffff;
      border: 1px solid #cdcfd0;
      border-radius: 6px;
      font-size: 13px;
      padding: 2.5px 10px;
    }
  }
  .course-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0 7px;
    max-width: 938px;
    margin-bottom: 20px;
    td,
    th {
      text-align: left;
      padding: 7px 8px;
      font-size: 13px;
      line-height: 150.5%;
    }
    tr th {
      text-transform: uppercase;
      :first-child {
        border-left: 5px solid transparent;
        padding-left: 15px;
      }
    }
    tr td {
      background: #f4f4d4;
      :first-child {
        border-left: 5px solid #947550;
        padding-left: 15px;
      }
      .close-icon-btn {
        width: 24px;
        height: 24px;
        background: #ffffff;
        border: 1px solid #cdcfd0;
        border-radius: 3px;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
      }
      input {
        padding: 0 10px;
        max-width: 250px;
        margin: 0;
      }
      .color-wrapper {
        display: flex;
        align-items: center;
        gap: 9px;

        #style1 {
          -webkit-appearance: none;
          -moz-appearance: none;
          appearance: none;
          width: 24px;
          height: 28px;
          background-color: transparent;
          border: none;
          cursor: pointer;
          padding: 0;
        }
        #style1::-webkit-color-swatch {
          border-radius: 4px;
          border: none;
        }
        #style1::-moz-color-swatch {
          border-radius: 4px;
          border: none;
        }
      }
    }
    .cross-icon-with-border {
      background: #ffffff;
      border: 1px solid #cdcfd0;
      border-radius: 3px;
      width: 24px;
      height: 24px;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;

export const BoxWrapper = styled.div`
  position: relative;

  .all-select-wrapper {
    display: flex;
    align-items: center;
    gap: 20px 40px;
    flex-wrap: wrap;
  }
  label {
    margin: 0;
  }
  /* &.no-side-border {
    ::after {
      display: none;
    }
  }
  ::after {
    content: "";
    display: block;
    position: absolute;
    background: #cdcfd0;
    height: 100%;
    width: 1px;
    right: 38px;
    top: 0;
  } */
  .cloud-icon {
    position: absolute;
    top: 7px;
    right: 10px;
  }
  .checkbox {
    border: 1px solid #cdcfd0;
    border-radius: 6px;
    padding: 0 10px;
    display: flex;
    align-items: center;
    min-width: 270px;
    min-height: 30px;
  }
  .MuiCheckbox-root {
    padding: 0;
    padding-right: 5px;
  }
  .MuiTypography-root {
    font-size: 13px;
    white-space: normal;
    padding-right: 30px;
  }
  label {
    font-size: 13px;
    color: #1d1d1d;
  }
`;

export const ActionWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  justify-items: flex-end;
  gap: 5px;
  margin-top: 10px;
  float: right;
  button {
    display: flex;
    align-items: flex-end;
    justify-items: flex-end;
    font-size: 13px;
    line-height: 150.5%;
    color: #1d1d1d;
    padding: 5px 15px;
    border: 1px solid #636f7c;
    border-radius: 30px;
    gap: 5px;
    background-color: #fff;
    font-family: "latoregular";
    white-space: nowrap;
    &.active {
      background: rgb(188, 155, 106);
      color: rgb(255, 255, 255);
      border-color: transparent;
      svg {
        path {
          fill: #fff;
        }
      }
    }
    :disabled {
      /* pointer-events: none; */
      opacity: 0.6;
      cursor: not-allowed;
    }
    &.reset-btn {
      border: none;
      text-decoration: underline;
    }
  }
`;

export const SiteDataRow = styled.div`
  display: grid;
  grid-template-columns: 240px 240px 240px;
  gap: 35px;
  &.first-row {
    /* padding-bottom: 16px; */
    margin-bottom: 16px;
    border-bottom: 1px dashed #000000;
    grid-template-columns: 240px 240px;
    max-width: 515px;
    button {
      margin-bottom: 16px;
    }
  }
  &.sec-row {
    margin-bottom: 10px;
  }
  button {
    background: linear-gradient(180deg, #947550 0%, #b59269 100%);
    border-radius: 6px;
    font-weight: 500;
    font-size: 14px;
    line-height: 150.5%;
    color: #ffffff;
    border: none;
    margin-bottom: 9px;
    min-height: 31px;
    font-family: "Roboto";
    max-width: 240px;
    :disabled {
      /* pointer-events: none; */
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
`;

export const SiteDataWorkSection = styled.div`
  padding: 28px 30px;
`;

export const TabContainer = styled.div`
  margin-top: 37px;
  .header-btn-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .save-btn-wrapper {
    display: flex;
    align-items: center;
    gap: 24px;
    button {
      text-transform: capitalize;
      background: #e7e7e7;
      border: 1px solid #636f7c;
      border-radius: 30px;
      color: #636f7c;
      font-weight: 400;
      padding-inline: 20px;
      height: 30px;
      font-size: 13px;
      line-height: 150.5%;
    }
  }
  .tab-btn-wrapper {
    button {
      color: #797979;
      font-weight: 500;
      font-size: 16px;
      line-height: 150.5%;
      border-bottom: 4px solid transparent;
      border-radius: 0;
      text-transform: capitalize;
      margin-right: 34px;
      padding-inline: 0;
      padding-top: 0;
      padding-bottom: 13px;
      &.active {
        color: #000000;
        border-color: #947550;
      }
    }
  }
`;
